module.exports = __webpack_public_path__ + "img/plus.9bd8b066.svg";